<template>
  <v-text-field
    class='w-text-field--input w-text-field--input--has-label w-order-rel-input'
    :label="label"
    :value="internalValue"
    type="number"
    min="0"
    outlined
    dense
    hide-details='auto'
    @change="internalValue = $event"
  >
    <template slot="prepend-inner">
      <v-menu>
        <template #activator="{ on }">
          <w-icon-button
            :icon="ORDER_RELATION[relation].icon"
            small
            v-on="on"
          />
        </template>
        <v-list>
          <v-list-item
            v-for="order of ORDER_RELATION"
            :key="order.id"
            @click="relation = order.id"
          >
            <w-icon>{{ order.icon }}</w-icon>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-text-field>
</template>

<script>
// components
import { VTextField } from 'vuetify/lib';

const ORDER_RELATION = Object.freeze({
  eq: { id: 'eq', icon: '$wEquals' },
  lt: { id: 'lt', icon: '$wSmallerThan' },
  gt: { id: 'gt', icon: '$wGreaterThan' }
});

export default {
  props: { 
    ...VTextField.options.props
  },
  data() {
    return {
      relation: this.value?.split(':')[0] ?? 'eq',
      internalValue: this.value?.split(':').pop() ?? undefined,
      ORDER_RELATION: ORDER_RELATION
    };
  },
  computed: {
    returnValue() {
      if (!this.internalValue || this.internalValue == '') return undefined;
      return `${ORDER_RELATION[this.relation].id}:${this.internalValue}`;
    }
  },
  watch: {
    returnValue() {
      this.$emit('input', this.returnValue);
    }
  }
};
</script>
